/**
 * SidebarContext
 *
 * Shares the sidebar's open/collapsed state with anything nested inside
 * AppShell — including things that render through a portal to
 * document.body (ModalPortal, MascotDialog's fullPage takeover). Portals
 * escape the DOM tree but not the React tree, so context still reaches
 * them; without this they have no way to know the sidebar is eating 256px
 * on the left and end up centring on the raw viewport instead of the
 * content pane next to it.
 *
 * AppShell is the only provider. Anything rendered outside an AppShell
 * (there shouldn't be any fixed-overlay consumers that are) falls back to
 * `open: false` — i.e. assumes no sidebar offset, the safe default.
 */

import { createContext, useContext } from 'react'

export const SIDEBAR_WIDTH = 256

const SidebarContext = createContext({ open: false })

export const SidebarProvider = SidebarContext.Provider

/** Pixels the content pane is pushed in from the left edge right now. */
export function useContentOffset() {
  const { open } = useContext(SidebarContext)
  return open ? SIDEBAR_WIDTH : 0
}
